<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-budget'>{{ translations('navbar.budget_control') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-budget'>{{ translations('budget.archive_budget') }}</router-link>
        </li>
        <li class='breadcrumb-item active' aria-current='page'>{{ translations('budget.budget_registration') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="d-flex flex-wrap">
        <div class="left-container">
          <h5 class="mb-3">{{ translations('budget.select_budget') }}</h5>
          <div class="form-inline mb-4">
            <div class="form-group">
              <select v-model="clients_id" class="custom-select" style="width: 300px;">
                <option value="0" selected>-</option>
                <option v-for="(client, i) in clients" :key="i" :value="client.id">{{client.name}}</option>
              </select>
            </div>
          </div>
          <h5 class="mb-3">Information</h5>
          <table class="table table-sm table-borderless table-information">
            <tbody>
              <tr>
                <th>{{ translations('budget.fiscal_year') }}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ selectedYear ? selectedYear : '-----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('budget.fiscal_year') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' min-value="1970" v-model="tempSelectedYear" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('year', tempSelectedYear, 'info05')">
                        {{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('budget.manager') }}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >{{ selectedContactName ? selectedContactName : '-----------' }}</button>
                  <div id='popover-info04' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('budget.manager') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="selectedContactIndex">
                        <option selected value="-1">-</option>
                        <option v-for="(contact, i) in contacts" :key="i" :value='i'>{{ contact.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button type='submit' class='btn btn-sm btn-primary' @click="updateField('contact', selectedContactIndex, 'info04')">
                        {{ translations('budget.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('budget.achievement_rate') }}</th>
                <td>0%</td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="form-inline">
            <div class="form-group">
              <a class="btn btn-link btn-sm text-danger" href="#">{{ translations('common.delete') }}</a>
            </div>
          </div>
        </div>
        <div class="right-container">
          <div class="form-inline justify-content-end"><!-- VAT -->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" id="defaultCheckTax" ref="defaultCheckTax" v-model="taxIncluded" @change="toggleTax()">
              <label class="form-check-label" for="defaultCheckTax">{{ translations('common.tax_included') }}</label>
            </div>
          </div>
          <div class="table-scroll mb-4">
            <table class="table table-sm table-striped table-hover table-clickable table-800">
              <thead>
                <tr>
                  <th>{{ translations('budget.month') }}</th>
                  <th>{{ translations('budget.sales_budget') }}</th>
                  <th>{{ translations('budget.sales_performance') }}</th>
                  <th>{{ translations('budget.sales_achievement_rate') }}</th>
                  <th>{{ translations('budget.sales_compared_previous_period') }}</th>
                  <th>{{ translations('budget.gross_profit_budget') }}</th>
                  <th>{{ translations('budget.gross_profit_performance') }}</th>
                  <th>{{ translations('budget.gross_profit_achievement_rate') }}</th>
                  <th>{{ translations('budget.gross_profit_comparison_previous_period') }}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
              <template v-for="(budget, i) in budgetDetails">
                <tr :key="i" :class="(budget.month == 0) ? 'pointer-none' : ''" :data-toggle="(budget.month != 0) ? 'modal' : ''" :data-target="(budget.month != 0) ? '#NewBudgetModal' : ''" @click="openEditModal(budget)">
                  <td>{{getMonthName(budget)}}</td>
                  <td class="right">{{toVatFormat(budget.sales_budget, '-----')}}</td>
                  <td class="right">{{toVatFormat(budget.sales_result, '-----')}}</td>
                  <td></td>
                  <td></td>
                  <td class="right">{{toVatFormat(budget.gross_profit_budget, '-----')}}</td>
                  <td class="right">{{toVatFormat(budget.gross_profit_result, '-----')}}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span class="table-percent-label">0%</span>
                      <div class="progress w-100"><div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 0%" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div></div>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
          <div class="form-inline">
            <div class="form-group">
              <button class="btn btn-sm btn-primary" @click="addBudget()">{{ translations('common.update') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewBudgetModal :currentBudget="currentBudget" :vat="{taxIncluded:taxIncluded, vatRate:vatRate}" /><!-- VAT -->
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import NewBudgetModal from '@/components/NewBudgetModal'
import { mapState } from 'vuex'

export default {
  name: 'NewBudget',
  components: {
    VueElementLoading,
    NewBudgetModal
  },
  props: {},
  data () {
    return {
      vatRate: 0, // VAT
      taxIncluded: false, // VAT
      isLoading: false,
      budgetInfo: {},
      budgetDetails: [],
      editMonthDetails: [],
      clients: [],
      selectedMonth: 1,
      clients_id: 0,
      contacts: [],
      selectedContactName: undefined,
      selectedContactID: -1,
      selectedContactIndex: -1,
      selectedYear: undefined,
      tempSelectedYear: '',
      tempBudgetDetails: [],
      currentBudget: {},
      monthNames: [
        '', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },
  watch: {
    tempBudgetDetails: {
      handler (value) {
        this.calcBudgetSum()
      },
      deep: true
    }
  },
  created: async function () {
    this.isLoading = true
    this.getVatRate() // VAT

    this.emptyDetail()
    await this.listClients()
    await this.listContacts()

    setTimeout(() => {
      this.isLoading = false
    }, 1000)
    setTimeout(() => {
      this.popoverButtons()
    }, 1500)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getMonthName (budget) {
      if (budget.month === 0) {
        return this.translations('budget.annual')
      } else {
        if (this.currentLanguage === 'en') {
          const monthNumber = parseInt(budget.month, 10)
          return this.monthNames[monthNumber]
        } else {
          const monthNumber = parseInt(budget.month, 10)
          return monthNumber + this.translations('budget.month')
        }
      }
    },
    async getVatRate () { // VAT
      try {
        let result = await this.$http.post(this.$api_url.vat_rate)
        console.log(JSON.stringify(result.data))
        if (result.data.status === true) {
          this.vatRate = result.data.vat_rate
          this.restoreTax()
        } else {
          this.$toastr.error('消費税率が取得できませんでした。', 'エラー')
          this.taxIncluded = false
          this.$refs['defaultCheckTax'].disabled = true
        }
      } catch (error) {
        console.log('NewBudget:getVatRate:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    restoreTax () { // VAT (rename *****)
      this.taxIncluded = this.$storage.get('NewBudget.taxIncluded', this.taxIncluded) ? this.$storage.get('NewBudget.taxIncluded', this.taxIncluded) : false
      console.log(this.taxIncluded)
    },
    toggleTax () { // VAT (rename *****)
      this.$storage.set('NewBudget.taxIncluded', this.taxIncluded)
      console.log(this.taxIncluded)
    },
    toVatFormat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target).toLocaleString()} (${Number(tax).toLocaleString()})`
        } else {
          return `${Number(tax).toLocaleString()} (${Number(target).toLocaleString()})`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    toVat (target, noData = null, taxIncluded = null, vatRate = null) { // VAT OUTPUT (Modal)
      if (target) {
        taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
        vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
        let tax = Math.round(target * (100 + vatRate) / 100)
        if (!taxIncluded) {
          return `${Number(target)}`
        } else {
          return `${Number(tax)}`
        }
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    noVatFormat (target, noData = null) { // VAT OUTPUT
      if (target) {
        return Number(target).toLocaleString()
      } else if (noData !== null) {
        return noData
      } else {
        return ''
      }
    },
    filterTax (target, taxIncluded = null, vatRate = null) { // VAT INPUT
      target = target || 0
      taxIncluded = taxIncluded === null ? this.taxIncluded : taxIncluded
      vatRate = vatRate === null ? Number(this.vatRate) : Number(vatRate)
      if (!taxIncluded) {
        return target
      } else {
        let noTax = Math.round(target / ((100 + vatRate) / 100))
        return noTax
      }
    },

    emptyDetail () {
      this.tempBudgetDetails = []
      for (let i = 1; i <= 12; i++) {
        this.tempBudgetDetails.push({
          month: i,
          sales_budget: 0,
          sales_result: 0,
          gross_profit_budget: 0,
          gross_profit_result: 0
        })
      }
    },

    calcBudgetSum () {
      this.budgetDetails = []
      let $this = this
      this.tempBudgetDetails.forEach(function (budget) {
        $this.budgetDetails.push(budget)
      })

      let sum = {
        month: 0,
        sales_budget: 0,
        sales_result: 0,
        gross_profit_budget: 0,
        gross_profit_result: 0
      }

      this.budgetDetails.forEach(function (budget) {
        sum.sales_budget += Number(budget.sales_budget)
        sum.sales_result += Number(budget.sales_result)
        sum.gross_profit_budget += Number(budget.gross_profit_budget)
        sum.gross_profit_result += Number(budget.gross_profit_result)
      })

      this.budgetDetails.unshift(sum)
    },

    async listClients () {
      try {
        let cList = await this.$http.post(this.$api_url.client_list)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewBudget:listClients')
        if ($data.success === true) {
          this.clients = $data.data
        } else {
          this.clients = [{ id: 0, name: 'No record.' }]
        }
      } catch (error) {
        console.log('NewBudget:listClients:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async listContacts () {
      try {
        let cList = await this.$http.post(this.$api_url.budget_contacts)
        let $data = this.$invoiceTools.prepareResult(cList.data, 'contacts', 'NewBudget:listContacts')

        console.log('NewBudget:listContacts:response', JSON.stringify($data))

        if ($data.success === true) {
          this.contacts = $data.data
        } else {
          this.contacts = []
        }

        // this.loadTestData()
      } catch (error) {
        console.log('NewBudget:listContacts:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    updateField (field, value, ref) {
      if (field === 'contact') {
        if (value === '-1') {
          this.selectedContactName = undefined
          this.selectedContactID = -1
          this.$refs[ref].innerText = '-----------'
        } else {
          this.selectedContactName = this.contacts[value].name
          this.selectedContactID = this.contacts[value].id
          this.$refs[ref].innerText = this.contacts[value].name
        }
      } else if (field === 'year') {
        this.selectedYear = value
        if (value) {
          this.$refs[ref].innerText = value
        } else {
          this.$refs[ref].innerText = '-----------?'
        }
      }

      window.$('#popover-' + ref).popoverX('hide')
    },
    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    openEditModal (budget) {
      this.currentBudget = {
        month: budget.month,
        sales_budget: this.toVat(budget.sales_budget), // VAT (Modal)
        sales_result: this.toVat(budget.sales_result),
        gross_profit_budget: this.toVat(budget.gross_profit_budget),
        gross_profit_result: this.toVat(budget.gross_profit_result)
      }
    },

    updateBudgetDetails (budget) {
      this.tempBudgetDetails[Number(budget.month) - 1] = budget
      this.calcBudgetSum()
    },

    async addBudget () {
      if (!this.clients_id || !Number(this.clients_id) || Number(this.clients_id) < 1) {
        this.$toastr.warning('新規登録する予算を選択してください。')
        return
      }
      if (!this.selectedYear || !Number(this.selectedYear) || Number(this.selectedYear) < 1) {
        this.$toastr.warning('年度を入力してください。')
        return
      }

      if (!this.selectedContactID || !Number(this.selectedContactID) || Number(this.selectedContactID) < 1) {
        this.$toastr.warning('担当者を選択してください。')
        return
      }

      this.$dialog.confirm('この予算を保存しますか?').then(async () => {
        try {
          this.isLoading = true

          let paramUpdate = {
            year: this.selectedYear,
            login_accounts_id: this.selectedContactID,
            clients_id: this.clients_id,
            months: this.tempBudgetDetails
          }
          console.log('NewBudgets:addBudget', JSON.stringify(paramUpdate))

          let addBudget = await this.$http.post(this.$api_url.budget_add, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(addBudget.data)

          console.log('NewBudgets:addBudget: ', JSON.stringify($data))
          if ($data.success === true) {
            this.$toastr.success('予算の保存に成功しました。', 'Success')
            this.$router.replace('archive-budget')
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
          this.isLoading = false
        } catch (error) {
          console.log('NewBudgets:addBudget:catch(error): ', JSON.stringify(error))
          this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    // テストデータ
    loadTestData () {
      this.contacts = [
        {
          id: 1,
          name: '山田太郎'
        },
        {
          id: 2,
          name: '田中二郎'
        },
        {
          id: 3,
          name: '伊藤守'
        }
      ]
    }
  }
}
</script>
